// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxField_wrapper__lo2UE","inline":"CheckboxField_inline__ic3cJ","checkbox":"CheckboxField_checkbox__ln+nv","label":"CheckboxField_label__yrYyf"};